module.exports = __webpack_public_path__ + "img/2024-12-12a_1.00863bde.jpg";